// src/App.jsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebaseConfig';
import { Menu } from 'lucide-react';

import IdleLogoutGuard from './components/IdleLogoutGuard';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Veiculos from './pages/Veiculos';
import Produtos from './pages/Produtos';
import OS from './pages/OS';
import Servicos from './pages/Servicos';
import Caixa from './pages/Caixa';
import Empresas from './pages/Empresa';
import VendasBalcao from './pages/VendasBalcao';
import Agenda from './pages/Agenda';
import Fornecedores from './pages/Fornecedores';
import Orcamentos from './pages/Orcamentos';
import NotasFiscais from './pages/NotasFiscais'; // ⬅️ NOVO
import Tutorial from './pages/Tutorial';         // ⬅️ NOVO

import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import HelpFab from './components/HelpFab';      // ⬅️ NOVO (botão flutuante de ajuda)
import { EmpresaProvider } from './context/EmpresaContext';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const dark = localStorage.getItem('darkMode') === 'true';
    document.documentElement.classList.toggle('dark', dark);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUsuario(user);
      setCarregando(false);
    });
    return () => unsubscribe();
  }, []);

  if (carregando) return <p className="p-6 text-center">Carregando...</p>;

  return (
    <EmpresaProvider>
      <Router>
        {usuario ? (
          // 🔒 Guard só nas rotas privadas
          // Para testar rápido troque para timeoutMin={1} warningSec={20}
          <IdleLogoutGuard timeoutMin={30} warningSec={60} redirectTo="/login">
            <div className="flex h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 overflow-hidden">
              <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

              <div className="flex flex-col flex-1 overflow-y-auto">
                <header className="md:hidden sticky top-0 bg-white dark:bg-gray-800 shadow-md z-20 flex items-center justify-between p-4">
                  <h1 className="text-xl font-bold">GestorPro</h1>
                  <button onClick={() => setIsSidebarOpen(true)}>
                    <Menu />
                  </button>
                </header>

                <main className="flex-grow p-4 sm:p-6">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/clientes/:clienteId/veiculos" element={<Veiculos />} />
                    <Route path="/caixa" element={<Caixa />} />
                    <Route path="/clientes" element={<Clientes />} />
                    <Route path="/empresas" element={<Empresas />} />
                    <Route path="/produtos" element={<Produtos />} />
                    <Route path="/os" element={<OS />} />
                    <Route path="/servicos" element={<Servicos />} />
                    <Route path="/orcamentos" element={<Orcamentos />} />
                    <Route path="/vendas-balcao" element={<VendasBalcao />} />
                    <Route path="/agenda" element={<Agenda />} />
                    <Route path="/fornecedores" element={<Fornecedores />} />

                    {/* 👇 NOVAS ROTAS */}
                    <Route path="/notas" element={<NotasFiscais />} />
                    <Route path="/notas-fiscais" element={<NotasFiscais />} />
                    <Route path="/tutorial" element={<Tutorial />} />

                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </main>

                {/* Botão flutuante de ajuda visível em todas as páginas autenticadas */}
                <HelpFab />

                <Footer />
              </div>
            </div>
          </IdleLogoutGuard>
        ) : (
          <div className="min-h-screen w-screen overflow-y-auto text-gray-900 dark:text-gray-100 bg-gray-50 dark:bg-gray-900">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          </div>
        )}
      </Router>
    </EmpresaProvider>
  );
}

export default App;
